import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiBratzGeneratorConfig } from '@/data/landingConfig/landingAiBratzGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiBratzGenerator } from './schemaObject';

interface Props {}
const AiBratzGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiBratzGenerator} />
			<LandingTemplate
				data={landingAiBratzGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiBratzGenerator;
